import { motion } from "framer-motion";

export const revealVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.08, ease: [0.2, 0.8, 0.2, 1] },
  }),
};

export function Reveal({ children, delay = 0, className = "", as: Tag = "div", ...rest }) {
  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-80px" }}
      custom={delay}
      variants={revealVariants}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function MaskLines({ lines = [], className = "", delay = 0.2, testid }) {
  return (
    <span className={className} data-testid={testid}>
      {lines.map((line, i) => (
        <span key={i} className="mask-line">
          <motion.span
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 1.05,
              delay: delay + i * 0.12,
              ease: [0.7, 0, 0.2, 1],
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
